import * as React from 'react';

import { TextField } from '@coursera/cds-core';
import type { TextFieldProps } from '@coursera/cds-core';

export type DebouncedTextFieldProps = Omit<TextFieldProps, 'onChange' | 'value'> & {
  onChange: (value: string) => void;
};

export const DebouncedTextField: React.VFC<DebouncedTextFieldProps> = (props) => {
  const ref = React.useRef<number | null>(null);
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error https://coursera.atlassian.net/browse/CDS-1401
    <TextField
      {...props}
      onChange={(event) => {
        const { value } = event.target;
        if (typeof process !== 'undefined' && process.env.JEST_WORKER_ID !== undefined) {
          // detecting nodejs (jest) so that tests are synchronous and easier to write
          props.onChange(value);
          return;
        }
        if (ref.current) {
          window.clearTimeout(ref.current);
        }
        ref.current = window.setTimeout(() => {
          props.onChange(value);
        }, 500);
      }}
    />
  );
};
